import styled from 'styled-components'

import { QuestionCircleIcon, Tooltip } from '@blade/ui-kit'

export const AnalysisTooltip = (props: {
  content: React.ReactNode
  children: React.ReactNode
}) => {
  return (
    <Tooltip content={props.content} align="center">
      <Root>
        <span>{props.children}</span>
        <QuestionCircleIcon size={14} />
      </Root>
    </Tooltip>
  )
}
const Root = styled.div`
  display: inline-flex;
  /* cursor: pointer; */
  gap: 3px;
  align-items: center;
`
